import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { isAzValid, isElValid } from 'common/utils/helpers';
import BeamRankList from './BeamRankList/BeamRankList';
import './BeamRankDisplay.css';

class BeamRankDisplay extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.customAzEl !== prevProps.customAzEl) {
      const { config } = this.props;
      if (
        this.props.customAzEl.az != null &&
        this.props.customAzEl.el != null &&
        this.props.customAzEl.az !== '' &&
        this.props.customAzEl.el !== '' &&
        Number.isInteger(this.props.customAzEl.az) &&
        Number.isInteger(this.props.customAzEl.el) &&
        isAzValid(this.props.customAzEl.az, config) && 
        isElValid(this.props.customAzEl.el, config)
      ) {
        this.props.setAzElInputError &&
          this.props.setAzElInputError({ az: this.props.azElInputError.az, el: this.props.azElInputError.el });
      }
    }
  }

  render() {
    return (
      <div className="BeamRankDisplay">
        <BeamRankList {...this.props} {...this.state} grandParent={this.props.parent} parent={this} />
        <div className="BeamRankDisplay_AzElInputError_Container">
          {this.props.azElInputError &&
            Object.keys(this.props.azElInputError).map((item, idx) => {
              return (
                <span key={idx} className="BeamRankDisplay_AzElInputError_Text">
                  {this.props.azElInputError[item]}
                </span>
              );
            })}
        </div>
      </div>
    );
  }
}

export default connect((store, ownProps) => {
  return {
    beamrank: ownProps.beamrank ?? store.data.heatmap.beamrank
  };
})(BeamRankDisplay);
